module.exports = __webpack_public_path__ + "static/media/3@1024w.ec2ab72d.jpg";